import { Flow } from "@/router/types";
import { SCREENS } from "@/router/screens";
import { Contract } from "@/types/contract";
import { isIdentifiedRequest } from "../helpers";

const isDeathDismantling = (contract?: Contract) => {
  return contract?.processReason === "demontage_02";
};

export const TCR_PROCESS: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => (isIdentifiedRequest(contract) ? SCREENS.CUSTOMER : SCREENS.IDENTIFICATION),
    back: () => null,
  },
  [SCREENS.IDENTIFICATION]: {
    next: () => SCREENS.CUSTOMER,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract) => (isDeathDismantling(contract) ? SCREENS.THANK_YOU : SCREENS.VIEW),
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
